import * as React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import { Typography, Paper, LinearProgress } from "@material-ui/core";
import { ResponsiveContainer, BarChart, XAxis, Legend, Bar, YAxis, CartesianGrid, Tooltip } from 'recharts';

import './MarketShareBookstoreCategoryEvolutionCategoryShare.scss';
import { QUERY_FILTER_MARKET_BOOKSTORE, QueryFilter } from '../../../../shared';
import { NumberPercent, NumberConvert } from '../../../../../services';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryEvolutionCategoryShareProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryEvolutionCategoryShareState {
    customFilter: {
        isChart: boolean
    },
}

export interface IMarketShareBookstoreCategoryEvolutionCategoryShareDataChart {
    category: string;
    
    group_sales: number;
    group_sales_percent: number | null;

    market_sales: number;
    market_sales_percent: number | null;

    you_sales: number;
    you_sales_percent: number | null;
}

const GQL_CATEGORY_EVOLUTION = gql`
query marketCategoryBookstoreSalesEvolutionByCategory($customFilter:  MarketShareCustomFilter) {
    marketCategoryBookstoreSalesEvolutionByCategory(marketShareCustomFilter: $customFilter) {
        category,
        group_sales,
        market_sales,
        you_sales
    }
}`;

const dataFilled = (data: any) => {
    return data && data.marketCategoryBookstoreSalesEvolutionByCategory && !!data.marketCategoryBookstoreSalesEvolutionByCategory.length
}

// statless component
const CustonTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
            <tr className="tooltip-text">
                    <td className="tooltip-title" colSpan={3}> {content && content.category} </td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Mercado:</td>
                    <td className="tooltip-content">{content && content.market_sales}</td>
                    <td className="tooltip-title">{content && content.market_sales_percent ? content.market_sales_percent.toFixed(2) : 0}%</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Rede de lojas:</td>
                    <td className="tooltip-content">{content && content.group_sales}</td>
                    <td className="tooltip-title">{content && content.group_sales_percent ? content.group_sales_percent.toFixed(2) : 0}%</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Lojas:</td>
                    <td className="tooltip-content">{content && content.you_sales}</td>
                    <td className="tooltip-title">{content && content.you_sales_percent ? content.you_sales_percent.toFixed(2) : 0}%</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};

// statless component
const MarketShareBookstoreCategoryEvolutionCategoryShareChart = ({ data, loading } : 
    { data: IMarketShareBookstoreCategoryEvolutionCategoryShareDataChart[], loading:boolean }) => (
        <ResponsiveContainer width="100%" height={370}>
            <BarChart data={data} margin={{ top: 15, right: 20, left: 20, bottom: 70 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis interval={0} dataKey="category"  tick={{fontSize: 10, angle: -90, dx: -3, dy: 50}}/>
                <YAxis  yAxisId="only" hide={true} />
                <Tooltip content={<CustonTooltipData isAnimationActive={false}  />} />
                <Legend verticalAlign="top" height={20}/>
                <Bar yAxisId="only" dataKey="market_sales_percent" name="Mercado" fill="#65cc93" />
                <Bar yAxisId="only" dataKey="group_sales_percent" name="Rede de lojas" fill="#323232" />
                <Bar yAxisId="only" dataKey="you_sales_percent" name="Lojas" fill="#00aeef" />
            </BarChart>
        </ResponsiveContainer>
);

export class MarketShareBookstoreCategoryEvolutionCategoryShare extends React.Component<IMarketShareBookstoreCategoryEvolutionCategoryShareProps, IMarketShareBookstoreCategoryEvolutionCategoryShareState> {

    constructor(props: IMarketShareBookstoreCategoryEvolutionCategoryShareProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };
        return  (
            <Query query={QUERY_FILTER_MARKET_BOOKSTORE} notifyOnNetworkStatusChange={true} >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                    return (
                        <Query query={GQL_CATEGORY_EVOLUTION} variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, [], false)} >
                        {({ loading, error, data, client}) => {
                            return (
                                <Paper className="publisher-sale-block panel-block" >
                                    <Typography variant="headline" className="panel-title" component="title">
                                        Vendas por Categoria x Mercado
                                    </Typography>

                                    {
                                        loading
                                        ?
                                        <LinearProgress />
                                        :
                                        (
                                            dataFilled(data)
                                            ?
                                            (
                                                <MarketShareBookstoreCategoryEvolutionCategoryShareChart 
                                                    data={this.convertData(data.marketCategoryBookstoreSalesEvolutionByCategory)}
                                                    loading={loading} 
                                                />
                                            )
                                            :
                                            (<Typography variant="body2" className="comparative" component="p">
                                                Não há informações de vendas
                                            </Typography>)
                                        )
                                    }
                                </Paper>
                            );
                        }}
                        </Query>
                    );
                }}
            </Query>
        )
    }

    private convertData = (data: any[]) => {

        const mappedData: IMarketShareBookstoreCategoryEvolutionCategoryShareDataChart[] = [];

        if(data) {
            let totalGroup : number = 0;
            let totalMarket : number = 0;
            let totalYour : number = 0;
            data.forEach(e => {
                totalGroup += e.group_sales ? Number.parseFloat(e.group_sales.toString()) : 0;
                totalMarket += e.market_sales ? Number.parseFloat(e.market_sales.toString()) : 0;
                totalYour += e.you_sales ? Number.parseFloat(e.you_sales.toString()) : 0;
            });

            data.forEach(e => {
                const item: IMarketShareBookstoreCategoryEvolutionCategoryShareDataChart = {
                    category: e.category && e.category.length > 17 ? e.category.substr(0,17) : e.category,

                    group_sales: e.group_sales ? Number.parseFloat(e.group_sales.toString()) : 0,
                    group_sales_percent: e.group_sales ? NumberPercent(totalGroup,NumberConvert(e.group_sales.toString())) : 0,

                    market_sales: e.market_sales ? Number.parseFloat(e.market_sales.toString()) : 0,
                    market_sales_percent: e.market_sales ? NumberPercent(totalMarket,NumberConvert(e.market_sales.toString())) : 0,

                    you_sales: e.you_sales ? Number.parseFloat(e.you_sales.toString()) : 0,
                    you_sales_percent: e.you_sales ? NumberPercent(totalYour,NumberConvert(e.you_sales.toString())) : 0
                };
                mappedData.push(item);
            })
        }

        return mappedData;
    }

}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/categoryShare/evolutionCategoryShare/MarketShareBookstoreCategoryEvolutionCategoryShare.tsx